const state = {
    error: null,
    tenantBranding: {
        data: null,
        expiredAt: null
    },
    // Tarjeta de vista previa del inicio (CatalogPreviewCard): catálogo +
    // primera página de productos. El editor y diseño no la leen; cualquier
    // escritura del catálogo o de productos la borra.
    catalogPreview: {
        data: null,
        tenantId: null,
        expiredAt: null
    }
};

export default state;
